module.exports = __webpack_public_path__ + "img/sos.388836b7.png";